import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import type RelativeMonthlyRecurrence from 'owa-service/lib/contract/RelativeMonthlyRecurrence';
import type RelativeYearlyRecurrence from 'owa-service/lib/contract/RelativeYearlyRecurrence';
import { isRelativeMonthlyRecurrence, isRelativeYearlyRecurrence } from './checkRecurrenceTypes';
import type DayOfWeekIndexType from 'owa-service/lib/contract/DayOfWeekIndexType';

export default function getRecurrenceDayOfWeekIndex(
    recurrence: RecurrenceType
): DayOfWeekIndexType | null {
    if (isRelativeMonthlyRecurrence(recurrence)) {
        const pattern = recurrence.RecurrencePattern as RelativeMonthlyRecurrence;
        return pattern.DayOfWeekIndex;
    } else if (isRelativeYearlyRecurrence(recurrence)) {
        const pattern = recurrence.RecurrencePattern as RelativeYearlyRecurrence;
        return pattern.DayOfWeekIndex;
    }

    return null;
}
